var map = {
	"./cnr/translation.toml": [
		36150,
		150
	],
	"./de/translation.toml": [
		1923,
		923
	],
	"./en/translation.toml": [
		17880,
		880
	],
	"./es-mx/translation.toml": [
		98393,
		393
	],
	"./fr/translation.toml": [
		27190,
		190
	],
	"./it/translation.toml": [
		32820,
		820
	],
	"./nl/translation.toml": [
		60382,
		382
	],
	"./ph/translation.toml": [
		16328,
		328
	],
	"./pl/translation.toml": [
		73869,
		869
	],
	"./pt-br/translation.toml": [
		31575,
		575
	],
	"./pt-pt/translation.toml": [
		73633,
		633
	],
	"./pt/translation.toml": [
		16873,
		873
	],
	"./template/translation.toml": [
		52959
	],
	"./uwu/translation.toml": [
		85206,
		206
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 99644;
module.exports = webpackAsyncContext;